import { render, staticRenderFns } from "./DisputeDetailsView.vue?vue&type=template&id=d0ec569e&"
import script from "./DisputeDetailsView.vue?vue&type=script&lang=js&"
export * from "./DisputeDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./DisputeDetailsView.vue?vue&type=style&index=0&id=d0ec569e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports